import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { CeramicCoatingPage } from './pages/CeramicCoatingPage';
import { PaintCorrectionPage } from './pages/PaintCorrectionPage';
import { AutoDetailingPage } from './pages/AutoDetailingPage';

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#050505]">
        <HashRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/ceramic-coating-fresno" element={<CeramicCoatingPage />} />
              <Route path="/paint-correction-fresno" element={<PaintCorrectionPage />} />
              <Route path="/mobile-detailing-fresno" element={<AutoDetailingPage />} />
            </Routes>
          </main>
          <Footer />
        </HashRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
